import React from 'react'
import styled from 'styled-components'
import { Title, Description } from './ProfileModal.styles'

// FIXME: Temmp
const Illustratrion = styled.div`
  height: 206px;
  width: 528px;
  justify-self: center;
  margin-top: 158px; /* stylelint-disable-line scales/space */
  background-color: #f0f0f0;
`

export const ContentContainer = styled.div`
  margin: 42px 0 60px; /* stylelint-disable-line scales/space */
`

export const IntroductionStep = () => {
  return (
    <>
      <Illustratrion />
      <ContentContainer>
        <Title>Create Your Public Profile</Title>
        <Description>
          Show the world what you do best with a public profile — your space to
          share Documents, Libraries, and Templates with the rest of the design
          community.
        </Description>
      </ContentContainer>
    </>
  )
}
